import classnames from 'classnames';
import React from 'react';
const EmptyListMessage = (props) => {
    if (props.buttonLink == '/') {
        throw new Error('buttonLink may never be /');
    }
    return (React.createElement("div", { className: classnames('row list__empty-message', props.className) },
        React.createElement("p", { className: `col-24 empty-message__text mb-${props.mb || 40}`, dangerouslySetInnerHTML: { __html: props.text } }),
        React.createElement("div", { className: classnames('col-24', { 'col-lg-8': !props.fullButton }) },
            React.createElement("a", { href: props.buttonLink, className: "button button--secondary full", onClick: () => (!!props.pushAnalytics ? props.pushAnalytics() : null) },
                React.createElement("span", null, props.buttonText)))));
};
export default EmptyListMessage;
